(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format =
        (window.PXUTheme &&
          window.PXUTheme.currency &&
          window.PXUTheme.currency.money_format) ||
        window.Shopify.money_format ||
        '£{{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }

    return (cents / 100).toFixed(2);
  }

  function getVariant(product, variantId) {
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function initCard(card) {
    var jsonEl = card.querySelector('[data-product-json]');
    var select = card.querySelector('[data-variant-select]');
    if (!jsonEl || !select) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (error) {
      return;
    }

    var priceEl = card.querySelector('[data-price]');
    var compareEl = card.querySelector('[data-compare]');
    var badgeEl = card.querySelector('[data-sale-badge]');
    var ctaEl = card.querySelector('[data-card-cta]');
    var mediaLink = card.querySelector('[data-card-media-link]');
    var titleLink = card.querySelector('[data-card-title-link]');

    function updateLinks(variantId) {
      var url = product.url + '?variant=' + variantId;
      if (ctaEl) ctaEl.href = url;
      if (mediaLink) mediaLink.href = url;
      if (titleLink) titleLink.href = url;
    }

    function setPriceAmount(text) {
      if (!priceEl) return;

      var prefix = priceEl.querySelector('[data-price-prefix]');
      var amountEl = priceEl.querySelector('[data-price-amount]');

      if (!amountEl) {
        amountEl = document.createElement('span');
        amountEl.setAttribute('data-price-amount', '');
        amountEl.className = 'money';
        priceEl.appendChild(amountEl);
      }

      if (prefix) {
        prefix.hidden = true;
      }

      amountEl.textContent = text;
    }
    function updatePrice(variant) {
      if (!variant) return;

      setPriceAmount(formatMoney(variant.price));
      var onSale =
        variant.compare_at_price && variant.compare_at_price > variant.price;

      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
        }
      }

      if (badgeEl) {
        badgeEl.hidden = !onSale;
      }
    }

    function onChange() {
      var variant = getVariant(product, select.value);
      if (!variant) return;
      updatePrice(variant);
      updateLinks(variant.id);
    }

    select.addEventListener('change', onChange);
    onChange();
  }

  function init() {
    document
      .querySelectorAll('[data-repolished-product-card][data-has-variant-picker]')
      .forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
